<a [href]="pubG?.link" target="_blank">
  <img  *ngIf="pubG?.imageName" [src]="publiciteImageUri + pubG?.imageName" width="100%" alt="Pub G" [title]="pubG?.titre" />
  <!--<img  *ngIf="!pubG?.imageName" src="assets/img/logo/pub2.png" width="100%" alt="Pub G" title="Pub G" />-->
</a>
